import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    Validators,
} from '@angular/forms';
import { AppStateFacade } from '@app-state';
import { IPasswordComplexity } from '@models';
import UiValidators, { UI_PASSWORD_MAX_LENGTH } from '@validators';

interface IPasswordChange {
    current: string;
    new: string;
}

@Component({
    selector: 'ui-user-profile-security',
    templateUrl: './user-profile-security.component.html',
    styleUrls: ['../../components/ui-forms/ui-setting-form.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiUserProfileSecurityComponent {
    @Input()
    public isLoading!: boolean;

    @Output()
    public submitPassword = new EventEmitter<IPasswordChange>();

    public formGroup: FormGroup;
    public passwordComplexity?: IPasswordComplexity;

    constructor(
        private _appState: AppStateFacade,
        fb: FormBuilder,
    ) {
        this.passwordComplexity = this._appState.settings.passwordComplexity;

        this.formGroup = fb.group(
            {
                'current': [
                    '',
                    Validators.compose([
                        Validators.required,
                        Validators.maxLength(UI_PASSWORD_MAX_LENGTH),
                    ])],
                'new': [
                    '',
                    Validators.compose([
                        Validators.required,
                        UiValidators.complexity(this.passwordComplexity!),
                        Validators.maxLength(UI_PASSWORD_MAX_LENGTH),
                    ])],
                'confirm': [''],
            },
            {
                validator: UiValidators.confirmPassword('new', 'confirm'),
            },
        );
    }
}
